export const OPEN_SG_DIALOG = 'OPEN_SG_DIALOG';
export const CLOSE_SG_DIALOG = 'CLOSE_SG_DIALOG';
export const SUBSCRIBE_SG_DIALOG_OPENED = 'SUBSCRIBE_SG_DIALOG_OPENED';
export const SUBSCRIBE_SG_DIALOG_CLOSED = 'SUBSCRIBE_SG_DIALOG_CLOSED';
export const UNMOUNT_DIALOG = 'UNMOUNT_DIALOG';

export const DIALOGS = {
  FILE_UPLOAD_VALIDATION: 'FILE_UPLOAD_VALIDATION'
};
